<!-- 组件说明 -->
<template>
  <div class="con hot-brand">
    <div class="brand-title">
      <h1>热门品牌</h1>
    </div>
    <div class="brand-box">
      <div class="brand-item" v-for="(item,index) in brandsList" :key="index">
        <img v-lazy="item.image" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
//import x from ''
export default {
  props:['brandsList'],
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style lang='scss' scoped >
.hot-brand {
  background-color: #ffffff;
  border-radius: 6px;
  margin: 34px auto 26px;
  overflow: hidden;
}
.brand-title {
  margin:34px 0  26px 0;
  padding-left: 30px;
  h1 {
    font-size: 22px;
    font-weight: 530;
    color: #333333;
  }
}
.brand-box {
   display: flex;
   flex-wrap: wrap;
  .brand-item:nth-child(n-1) {
    margin-bottom: 30px;
    img{
      @include size(100%,100%)
    }
   
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/main/home/components/home-brand.vue